import populateSubmitterItem from './populate_submitter_item'

// Synexis: modal "Selecionar dos contatos" no fluxo de envio. Um único <contacts-picker> envolve
// o formulário e o <dialog>; cada signatário tem um gatilho [data-contacts-trigger]. Ao clicar no
// gatilho guardamos o <submitter-item> alvo, abrimos o modal e listamos contatos via
// /submitters_autocomplete (q em branco => todos). Ao escolher, preenchemos o alvo (fonte única
// populateSubmitterItem, a mesma do autocomplete embutido).
export default class extends HTMLElement {
  connectedCallback () {
    this.dialog = this.querySelector('dialog')
    this.searchInput = this.querySelector('[data-contacts-search]')
    this.resultsEl = this.querySelector('[data-contacts-results]')

    this.addEventListener('click', this.onClick)
    this.searchInput?.addEventListener('input', this.onSearch)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.onClick)
    this.searchInput?.removeEventListener('input', this.onSearch)
    clearTimeout(this.debounce)
  }

  onClick = (e) => {
    const trigger = e.target.closest('[data-contacts-trigger]')

    if (trigger && this.contains(trigger)) {
      e.preventDefault()
      this.currentItem = trigger.closest('submitter-item')
      this.open()

      return
    }

    const row = e.target.closest('[data-contact-row]')

    if (row) {
      e.preventDefault()
      populateSubmitterItem(this.currentItem, JSON.parse(row.dataset.contact))
      this.dialog.close()
    }
  }

  open () {
    if (!this.dialog) return

    this.dialog.inert = false
    this.dialog.showModal()

    if (this.searchInput) this.searchInput.value = ''

    this.load('')

    this.searchInput?.focus()
  }

  onSearch = () => {
    clearTimeout(this.debounce)

    this.debounce = setTimeout(() => this.load(this.searchInput.value), 200)
  }

  load (q) {
    // Sem `field`: o backend casa por nome OU e-mail (q em branco => todos os contatos).
    const params = new URLSearchParams({ q })

    fetch('/submitters_autocomplete?' + params)
      .then((resp) => resp.json())
      .then((items) => this.renderResults(items))
      .catch(() => this.renderResults([]))
  }

  renderResults (items) {
    if (!this.resultsEl) return

    this.resultsEl.replaceChildren()

    if (!items.length) {
      const empty = document.createElement('div')

      empty.className = 'p-3 text-sm text-base-content/60'
      empty.textContent = this.dataset.emptyText || ''

      this.resultsEl.appendChild(empty)

      return
    }

    items.forEach((item) => {
      const row = document.createElement('button')

      row.type = 'button'
      row.dir = 'auto'
      row.setAttribute('data-contact-row', '')
      row.dataset.contact = JSON.stringify(item)
      row.className = 'w-full text-left p-2 hover:bg-base-200 rounded flex flex-col'

      const name = document.createElement('span')

      name.className = 'font-medium'
      name.textContent = item.name || item.email

      const detail = document.createElement('span')

      detail.className = 'text-xs text-base-content/60'
      detail.textContent = [item.email, item.cpf, item.empresa].filter(Boolean).join('   ·   ')

      row.append(name, detail)
      this.resultsEl.appendChild(row)
    })
  }
}
